import { inject, observer } from "mobx-react";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import React from "react";
import styled from "@emotion/styled";

import AuthStore from "app/AuthStore";
import config from "config";

const UserInfoWrapper = styled("div")`
  padding: 20px 10px 10px;
`;

const Title = styled("h4")`
  color: #eee;
  margin-bottom: 0;
`;

const Version = styled("small")`
  font-size: 0.75em;
`;

const DisplayName = styled("div")`
  color: #999;
`;

interface UserInfoProps {
  authStore?: AuthStore;
}

const UserInfo = inject("authStore")(
  observer(({ authStore }: UserInfoProps) => {
    const { displayName, logout } = authStore!;
    return (
      <UserInfoWrapper>
        <Title>
          Lawfully Intra
          <br />
          <Version>v{config.version}</Version>
        </Title>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item>
                <a onClick={logout}>Sign Out</a>
              </Menu.Item>
            </Menu>
          }
        >
          <DisplayName>
            {displayName} <DownOutlined />
          </DisplayName>
        </Dropdown>
      </UserInfoWrapper>
    );
  }),
);

export default UserInfo;
